import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          {/* Breadcrumb */}
          <nav className="mb-8">
            <ol className="flex items-center gap-2 text-sm text-text-secondary">
              <li>
                <Link to="/" className="hover:text-text-primary transition-colors cursor-pointer">
                  ホーム
                </Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li className="text-text-primary font-medium">利用規約</li>
            </ol>
          </nav>

          {/* Page Title */}
          <h1 className="text-5xl font-black font-maru text-text-primary mb-4">
            利用規約
          </h1>
          <p className="text-text-secondary text-sm mb-12">
            最終更新日: 2025年12月15日
          </p>

          {/* Content */}
          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第1条(適用)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                本規約は、赤ちゃんダイアリー(以下「本アプリ」といいます)の利用に関する条件を、本アプリを利用するすべてのユーザー(以下「ユーザー」といいます)と当運営との間で定めるものです。
              </p>
              <p className="text-text-secondary leading-relaxed">
                ユーザーは、本アプリを利用することにより、本規約に同意したものとみなされます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第2条(本アプリの利用)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                本アプリは、ユーザー登録なしでご利用いただけます。ユーザーは、本アプリを利用することにより、本規約に同意したものとみなされます。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本アプリは無料でご利用いただけます
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    アカウント登録は不要です
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本規約に同意の上、ご利用ください
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第3条(禁止事項)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                ユーザーは、本アプリの利用にあたり、以下の行為をしてはなりません。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    法令または公序良俗に違反する行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    犯罪行為に関連する行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    当運営、本アプリの他のユーザー、または第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本アプリのネットワークまたはシステム等に過度な負荷をかける行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本アプリの運営を妨害するおそれのある行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    不正アクセスをし、またはこれを試みる行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    他のユーザーに関する個人情報等を収集または蓄積する行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    不正な目的を持って本アプリを利用する行為
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    その他、当運営が不適切と判断する行為
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第4条(本アプリの提供の停止等)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本アプリの全部または一部の提供を停止または中断することができるものとします。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本アプリにかかるコンピュータシステムの保守点検または更新を行う場合
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    地震、落雷、火災、停電または天災などの不可抗力により、本アプリの提供が困難となった場合
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    コンピュータまたは通信回線等が事故により停止した場合
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    その他、当運営が本アプリの提供が困難と判断した場合
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第5条(利用制限)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、ユーザーに対して、本アプリの全部もしくは一部の利用を制限することができるものとします。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本規約のいずれかの条項に違反した場合
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    その他、当運営が本アプリの利用を適当でないと判断した場合
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第6条(保証の否認および免責事項)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営は、本アプリに事実上または法律上の瑕疵(安全性、信頼性、正確性、完全性、有効性、エラーやバグなどを含みます。)がないことを明示的にも黙示的にも保証しておりません。
              </p>
              <p className="text-text-secondary leading-relaxed">
                当運営は、本アプリに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。ただし、本アプリに関する当運営とユーザーとの間の契約(本規約を含みます。)が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第7条(サービス内容の変更等)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                当運営は、ユーザーに通知することなく、本アプリの内容を変更しまたは本アプリの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第8条(利用規約の変更)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                当運営は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。変更後の本規約は、本サイト内に掲示された時点から効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第9条(個人情報の取扱い)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                当運営は、本アプリの利用によって取得する個人情報については、当運営「
                <Link
                  to="/privacy"
                  className="text-cta font-bold hover:underline cursor-pointer"
                >
                  プライバシーポリシー
                </Link>
                」に従い適切に取り扱うものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第10条(準拠法・裁判管轄)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                本規約の解釈にあたっては、日本法を準拠法とします。
              </p>
              <p className="text-text-secondary leading-relaxed">
                本アプリに関して紛争が生じた場合には、当運営の本店所在地を管轄する裁判所を専属的合意管轄とします。
              </p>
            </section>

            <section className="pt-8 border-t border-text-secondary/20">
              <p className="text-text-secondary text-sm text-center">
                以上
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
